import { render } from "./UserProfileListNav.vue?vue&type=template&id=1f541b23&ts=true"
import script from "./UserProfileListNav.vue?vue&type=script&lang=ts"
export * from "./UserProfileListNav.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__